import { DashboardService } from './../../../../../../service/events/dashboard.service';
import { Component, Input, OnDestroy } from '@angular/core';
import { Utils } from '../../../../../../common/utils';
import { BaseView } from '../../../../../../view/base-view';

import { environment } from '../../../../../../../environments/environment';
import { RequestHandler } from '../../../../../../service/OffService/request-handler';

import type { FormField } from '@fitogest/reactive-form-builder/interfaces';
import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';
import { CosteModel } from 'src/app/models/coste.model';

@Component({
    selector: 'app-costes-tareas-fertilizantes',
    standalone: false,
    templateUrl: './costes-tareas-fertilizantes.component.html',
    styleUrls: ['./costes-tareas-fertilizantes.component.scss']
})
export class CostesTareasFertilizantesComponent extends BaseView<CosteModel> implements OnDestroy {
    @Input() override model: CosteModel = {};
  
    public fincaName = environment.features.fincaName;
    public fincasName = environment.features.fincasName;
    public appName = environment.appName;

    public override canShow: Record<string, boolean> = {};
   
    public ps = 0;

    public mostrarTratamientosAplicados = true;


    public distributionOrder = [4];

  
    auxTotalTrabajadores = 0;
    showTarea = false;
    showTareaFito = false;
    showTareaFerti = false;
    forFields: FormField<object>[] = [];

 
    constructor(
        dashboard: DashboardService
    ) {
        super(dashboard , new RequestHandler(), undefined );
    }

    public moneyFormat(input: number) {
        return Utils.decimalFormat(input, 2);
    }

    public cuantityFormat(input: number) {
        return Utils.decimalFormat(input, 1);
    }

    public override show(modal: string, data: CosteModel) {
        let x;

        this.model = data;
        this.canShow[modal] = true;

        for (x in this.canShow) {
            if (x !== modal && this.canShow[x]) {
                this.canShow[x] = false;
            }
        }
    }

    public override hide(modal: string) {
        this.model = {};
        this.canShow[modal] = false;
      
    }
    

    public override ngOnDestroy() {
        Utils.unsuscribe([
           
        ]);
    }

    public transformStringToNumber( value: string ): number {
        if ( value == null || value.length === 0  ) {
            return 0;
        }
        return parseFloat(value);
    }

    public sumaAuxTrabajadores( horas: string | null ) {
        const trabajadores: MantenimientoModel[] | null = this.model.lista_trabajadores ?? null;
        let suma =  0;
        if ( trabajadores == null ) {
            return suma;
        }
        for (const trabajador of trabajadores) {
            if (trabajador.aux_cargos == null || horas == null ) {
                suma += 0;
            } else {
                suma += trabajador.aux_cargos * this.transformStringToNumber(horas);
            }
        }
        return suma;
    }


    public tipoTarea( tarea: string ) {
        this.showTarea = false;
        this.showTareaFito = false;
        this.showTareaFerti = false;
        if ( tarea == null || tarea.length === 0) {
            this.showTarea = true;
            return;
        }

        if ( tarea === 'Tareas fitosanitarias' ) {
            this.showTareaFito = true;
            return;
        }
        
        if ( tarea === 'Tareas fertilizantes' ) {
            this.showTareaFerti = true;
            return;
        }
        this.showTarea = true;
        return;

    }
}